import * as React from 'react';
import { shouldThrowError as H } from './contact-channels71.js';

var i=(r,e)=>{(r.suspense||r.throwOnError||r.experimental_prefetchInRender)&&(e.isReset()||(r.retryOnMount=false));},E=r=>{React.useEffect(()=>{r.clearReset();},[r]);},R=({result:r,errorResetBoundary:e,throwOnError:t,query:a,suspense:o})=>r.isError&&!e.isReset()&&!r.isFetching&&a&&(o&&r.data===void 0||H(t,[r.error,a]));

export { i as ensurePreventErrorBoundaryRetry, R as getHasError, E as useClearResetErrorBoundary };
//# sourceMappingURL=contact-channels120.js.map
